import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gfu-table__row gfu-tree__leaf gfu-table__row--single gfu-table__row--nested gfu-table__row--outline" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "gfu-table__thumb _fl" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "gfu-table__cell gfu-table__cell--grow _pt-1 _pb-1" }
const _hoisted_6 = {
  class: "gfu-table__text--small _screen--not-s",
  "data-qa": "cart-table:ProductQuantity"
}
const _hoisted_7 = {
  key: 0,
  class: "gfu-1of1 gfu-11of12--s gfu-2of3--m gfu-flex__container"
}
const _hoisted_8 = { class: "gfu-table__cell gfu-table__cell--grow" }
const _hoisted_9 = { class: "gfu-table__cell gfu-table__option-action gfu-table__option-action--large" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 1,
  "data-qa": "cart-table:ProductOptionValue"
}
const _hoisted_13 = {
  class: "gfu-table__cell gfu-table__cell--actions _tac _flexb15 _flexb10--s _screen--none _screen--s _flexcntr",
  "data-qa": "cart-table:ProductQuantity"
}
const _hoisted_14 = {
  key: 0,
  class: "gfu-table__cell _tar _pa-0 _flexb5 _screen--none _screen--s"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_product_option_field = _resolveComponent("product-option-field")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["gfu-table__cell gfu-table__cell-row gfu-table__cell-product-option _pa-0", [{ 'gfu-table__cell-product-option--non-editable': !_ctx.allowEditing}]])
    }, [
      _createElementVNode("div", {
        class: "_screen--none _screen--s",
        href: _ctx.item.product.productUrl
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _ctx.item.product.imageUrl,
            alt: _ctx.item.displayName
          }, null, 8 /* PROPS */, _hoisted_4)
        ])
      ], 8 /* PROPS */, _hoisted_2),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.item.quantity) + "x ", 1 /* TEXT */),
        _createVNode(_component_router_link, {
          to: $options.itemDetailsRoute,
          class: "gfu-table__text--strong gfu-table__text--small",
          onClick: $options.onItemDetailsClick,
          "data-qa": "cart-table:ProductName"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.item.displayName), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["to", "onClick"]),
        (_ctx.canEditOption)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.product.options.filter(o => o.values.length > 0), (option) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `set-item-option-${option.productOptionID}`
                  }, [
                    _createVNode(_component_product_option_field, {
                      ref_for: true,
                      ref: 'option-sub-' + _ctx.item.orderItemID,
                      "label-class": "gfu-field__label--light",
                      "field-class": "gfu-field-select--tiny-text gfu-field-select--squeezed",
                      option: option,
                      small: true,
                      "selected-option-value-id": _ctx.getProductOptionValueID(_ctx.item.options, option.productOptionID),
                      "order-item-id": _ctx.item.orderItemID,
                      onChange: _ctx.setOrderItemOption
                    }, null, 8 /* PROPS */, ["option", "selected-option-value-id", "order-item-id", "onChange"])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createElementVNode("div", _hoisted_9, [
                ($options.canSplitItem)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      disabled: _ctx.isProcessing,
                      class: "gfu-btn gfu-btn--circle gfu-btn--light-flat gfu-btn--icon",
                      onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($options.splitSetItem()), ["prevent"]))
                    }, [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("span", {
                        class: "_ga _ga--split-icon gfu-btn__icon",
                        title: "Split item",
                        "data-qa": "begin-order-form-button:SplitItem"
                      }, null, -1 /* CACHED */)
                    ]))], 8 /* PROPS */, _hoisted_10))
                  : _createCommentVNode("v-if", true),
                ($options.canRemoveItem)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      disabled: _ctx.isProcessing,
                      class: "gfu-btn gfu-btn--circle gfu-btn--light-flat gfu-btn--icon",
                      onClick: _cache[1] || (_cache[1] = _withModifiers($event => ($options.removeSetItem()), ["prevent"]))
                    }, [
                      _createVNode(_component_base_icon, {
                        name: "times",
                        class: "gfu-btn__icon",
                        title: "Undo split",
                        "data-qa": "begin-order-form-button:UndoSplit"
                      })
                    ], 8 /* PROPS */, _hoisted_11))
                  : _createCommentVNode("v-if", true)
              ])
            ]))
          : (_ctx.item.product.options.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString($options.getReadonlyProductOptionValuesList(_ctx.item)), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
      ])
    ], 2 /* CLASS */),
    _createElementVNode("div", _hoisted_13, [
      _createTextVNode(_toDisplayString(_ctx.item.quantity) + " ", 1 /* TEXT */),
      (_ctx.isQuantityWrong)
        ? (_openBlock(), _createBlock(_component_tooltip, {
            key: 0,
            class: "gfu-table__amount-error-wrapper gfu-table__amount-error-wrapper--inline",
            text: _ctx.quantityErrorText,
            "data-qa": "quantity-error-warning-icon-tooltip"
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createElementVNode("span", {
                class: "gfu-table__amount-error",
                "data-qa": "cart-table-item-row-quantity-error:WarningIcon"
              }, null, -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["text"]))
        : _createCommentVNode("v-if", true)
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("div", {
      class: "gfu-table__cell _tar _flexb35 _flexb25--s _flexb15--m _screen--none _screen--s",
      "data-text": "Total price"
    }, "-", -1 /* CACHED */)),
    (_ctx.allowEditing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14))
      : _createCommentVNode("v-if", true)
  ]))
}